import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLandAcquisitionRequests, fetchSystemConfigs } from "../../store/actions/adminActions";

export function useLandAcquisitionRequests() {
    const dispatch = useDispatch();
    const { landAquisitionRequests: acquisitionRequests, isLoading, pagination, systemConfig } = useSelector((state) => state.admin);

    const [filterStatus, setFilterStatus] = useState("");
    const [filterMemberType, setFilterMemberType] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        dispatch(fetchLandAcquisitionRequests({
            page: currentPage,
            status: filterStatus || undefined,
            memberType: filterMemberType || undefined,
            search: searchQuery || undefined
        }));
    }, [dispatch, currentPage, filterStatus, filterMemberType, searchQuery]);


    useEffect(() => {
        dispatch(fetchSystemConfigs())
    }, [dispatch]);

    const handleFilterChange = (status) => {
        setFilterStatus(status);
        setCurrentPage(1);
    };

    const handleMemberTypeChange = (memberType) => {
        setFilterMemberType(memberType);
        setCurrentPage(1);
    };

    const handleSearch = (e) => {
        if (e) e.preventDefault();
        setCurrentPage(1);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const resetFilters = () => {
        setFilterStatus("");
        setFilterMemberType("");
        setSearchQuery("");
        setCurrentPage(1);
    };

    return {
        acquisitionRequests,
        systemConfig,
        isLoading,
        pagination,
        filterStatus,
        filterMemberType,
        searchQuery,
        currentPage,
        setSearchQuery,
        handleFilterChange,
        handleMemberTypeChange,
        handleSearch,
        handlePageChange,
        resetFilters,
        refreshRequests: () => {
            dispatch(fetchLandAcquisitionRequests({
                page: currentPage,
                status: filterStatus || undefined,
                memberType: filterMemberType || undefined,
                search: searchQuery || undefined
            }));
        }
    };
}